var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var PassLevelWinTTShareVideo = xClass("PassLevelWinTTShareVideo", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/tiktok_share.csb")
})

let TTWinShareVideoRes = ["packed/TTWinShareVideoRes.pack"];

PassLevelWinTTShareVideo.show = function (path, topic, rewards, failCb, levelId) {
    cc.log("#### PassLevelWinTTShareVideo ####", path, topic, rewards, levelId)
    var resSuccess = function() {
        PassLevelWinTTShareVideo.create(path, topic, rewards);
    }
    onFail = failCb || Toast.make(getText("error.tip.load_res_error"));
    onCancel = failCb || Toast.make(getText("error.tip.load_canceled"));
    preloadWithLoading(TTWinShareVideoRes, resSuccess, onFail, onCancel)
}

PassLevelWinTTShareVideo.prototype.ctor = function (path, topic, rewards, levelId) {
    var self = this;
    self.bind(self);
    BasePanel.prototype.init.call(self);
    
    self.levelId = levelId;
    self.init(path, topic, rewards);
    self.popup();

    self.notHideBannerOnClose();
}


PassLevelWinTTShareVideo.prototype.init = function (path, topic, rewards) {
    var self = this;
    self.check = true;

    quickBuildUIButton(self.getChildByName("close_x"), ()=>{
        self.onClose();
    })
    
    var shareBtn = self.getChildByName("btn_orange_start");
    label = shareBtn.getChildByName("label");
    label.setString(getText("douyin_video_share_button"));
    shareBtn.getChildByName("label").x += 4;
    shareBtn.getChildByName("label").y -= 2;

    var uiShareBtn = UIGroupButton.create(shareBtn);
    PushBounceAnim.create(uiShareBtn);
    ButtonPushBounceIdleBubbleAnim.create(uiShareBtn);
    uiShareBtn.on(UIButtonEvent.Click, function(){
        DCAssist.userTrack("douyin_video_share", "video_share_click", {click_type:"icon", current_stage:self.levelId});
        mini.shareAppMessage({
            channel: "video",
            templateId: "",
            extra: {
                videoPath: path,
                videoTopics: topic,
                hashtag_list:topic
            },
            success(){
                console.log("分享成功");
                DCAssist.userTrack("douyin_video_share", "video_share_success", {click_type:"share", current_stage:self.levelId});
                var rewardSuccess = function(evt){
                    console.log("分享领奖成功");
                    UserManager.getInstance().getDailyData().douyinShareVideoCnt = evt.data.times;
                    var rewardData =  evt.data.rewardItems;
            
                    for (const key in rewardData) {
                        var oneReward = rewardData[key];
                        UserProp.getInstance().rewardProp(oneReward.itemId, oneReward.num, null, null, ModuleName.TT_VIDEO_SHARE);
                        var pos = self.convertToWorldSpace(cc.p(0, 0));
                        var flyItemOps = table();
                        table.insert(flyItemOps, table(
                            [1, "itemId", oneReward.itemId],
                            [1, "num", oneReward.num],
                            [1, "pos", pos],
                            [1, "scale", 0.5]
                        ));
                        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
                    }
            
                    self.onClose();
                }
                var rewardFail = function(){
                    console.log("分享领奖失败");
                }
                var http = TTlightgameVideoShareRewardHttp.new();
                http.addEventListener(Events.kComplete, rewardSuccess);
                http.addEventListener(Events.kError, rewardFail);
                http.addEventListener(Events.kCancel, rewardFail);
                http.load();
            },
            fail(e) {
                console.log("分享失败", e);
            }
        });
    });
    
    self.getChildByName("txt").setString(getText("douyin_video_share_title"));
    // self.getChildByName("txt").setScale(35/40);
    // self.getChildByName("txt").setNextFontPositionXOffset(-3);
    self.getChildByName("txt").x += 35;
    self.getChildByName("txt").y -= 7;

    var bubble = self.getChildByName("bubblebox_prompt_node");
    if (!rewards || rewards.length == 0){
        bubble.setVisible(false);
    }else{
        var bubbleBox = bubble.getChildByName("bubblebox1");
        bubbleBox.width = 340;
        bubbleBox.x = -170;
        var txt = bubble.getChildByName("txt");
        txt.setString(getText("douyin_video_share_bubble"));
        txt.x = -158
        txt.y = 11

        var icon = bubble.getChildByName("icon");
        var pos1 = icon.getPosition();
        icon.removeFromParent();
        var icon = bubble.getChildByName("icon");
        var pos2 = icon.getPosition();
        icon.removeFromParent();
        bubble.getChildByName("x1000").removeFromParent();
        bubble.getChildByName("x1000").removeFromParent();

        rewards.sort((a, b)=>{
            if (b.id == "2"){
                return -1;
            }
        })
        if (rewards.length > 1){
            var icon1 = UIItemBuilder.createProp(rewards[0].id, rewards[0].num, 1)[0];
            bubble.addChild(icon1);
            icon1.setPosition(pos1.x+36, pos1.y-27);
            icon1.setScale(0.7);
            var icon2 = UIItemBuilder.createProp(rewards[1].id, rewards[1].num, 1)[0];
            bubble.addChild(icon2);
            icon2.setPosition(pos2.x+30, pos2.y-27);
            if (rewards[1].id == "2"){
                icon2.x = pos2.x-5;
            }
            icon2.setScale(0.7);
        }else{
            var icon1 = UIItemBuilder.createProp(rewards[0].id, rewards[0].num, 1)[0];
            bubble.addChild(icon1);
            icon1.setPosition(pos1.x-15, pos1.y-27);
            icon1.setScale(0.7);
        }
    }
}

PassLevelWinTTShareVideo.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(display.width / 2, 650 + dH/2));
    var pos_O = cc.p(display.width / 2, display.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

PassLevelWinTTShareVideo.prototype.onCleanup = function () {
    ResManager.release(TTWinShareVideoRes);
}

module.exports = PassLevelWinTTShareVideo;